module.exports = __webpack_public_path__ + "img/customer_code.97f94cd7.png";